// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import BodyCopy from '../../../atoms/BodyCopy';
import Badge from '../../../atoms/Badge';
import CardImage from '../../CardImage';
import withStyles from '../../../hoc/withStyles';
import CardStyle from '../Card.style';

/**
 * @function Card The card component will render an card
 * that is constructed from the card prop passed.
 * @param {string} className The class name for the component
 * @param {object} card card object
 */
const getAddressfromDiffLines = (address, dataLocatorPrefix) => {
  return (
    <React.Fragment>
      <BodyCopy
        fontFamily="secondary"
        tag="p"
        data-locator={dataLocatorPrefix ? `${dataLocatorPrefix}-addressline1` : ''}
      >
        {address.addressLine1}
      </BodyCopy>
      <BodyCopy
        fontFamily="secondary"
        tag="p"
        data-locator={dataLocatorPrefix ? `${dataLocatorPrefix}-addressline2` : ''}
      >
        {address.addressLine2}
      </BodyCopy>
    </React.Fragment>
  );
};

const getFormattedAddress = (address, dataLocatorPrefix) => {
  return (
    <React.Fragment>
      <BodyCopy
        component="p"
        data-locator={dataLocatorPrefix ? `${dataLocatorPrefix}-cityfullname` : ''}
        fontFamily="secondary"
      >
        {`${address.city ? `${address.city}, ` : ''}${address.state ? `${address.state} ` : ''}${
          address.zipCode
        }`}
      </BodyCopy>
    </React.Fragment>
  );
};

const getClassName = (
  className,
  spc,
  selectedValue,
  id,
  isDefault,
  isExpired,
  isMakeDefaultUxUpdateEnabled
) => {
  let style = className;
  if ((spc && selectedValue === id) || (isDefault && !selectedValue)) {
    style = `${className} active-credit-card`;
    if (isExpired && isMakeDefaultUxUpdateEnabled) {
      style = `${style} active-card-expired`;
    }
  }
  return style;
};

const getCardHolderDetails = (spc, fontWeight, dataLocatorPrefix, card) => {
  if (!spc) {
    return (
      <BodyCopy
        component="p"
        fontWeight={fontWeight}
        fontFamily="secondary"
        className="card-name"
        data-locator={dataLocatorPrefix ? `${dataLocatorPrefix}-fullname` : ''}
      >
        {`${card.addressDetails.firstName} ${card.addressDetails.lastName}`}
      </BodyCopy>
    );
  }
  return null;
};

const Card = ({
  card,
  className,
  dataLocatorPrefix,
  fontWeight,
  isDefault,
  cardNumber,
  showAddress,
  onSelect,
  spc,
  selectedValue,
  isExpired,
  isMakeDefaultUxUpdateEnabled,
}) => {
  const labelObj = {
    checkout: {
      billing: {
        lbl_billing_default_card: 'DEFAULT',
      },
    },
  };

  const billingLabels = getLabelFromCopyOrFromTranslation('checkout.billing', labelObj);

  return (
    card && (
      <BodyCopy
        component="div"
        fontSize="fs16"
        color="text.primary"
        className={getClassName(
          className,
          spc,
          selectedValue,
          card.creditCardId,
          isDefault,
          isExpired,
          isMakeDefaultUxUpdateEnabled
        )}
        onClick={spc ? () => onSelect(card) : null}
      >
        <BodyCopy component="div" fontFamily="secondary" className="card-title">
          {getCardHolderDetails(spc, fontWeight, dataLocatorPrefix, card)}
          {isDefault && !spc ? (
            <Badge
              showCheckmark
              dataLocator="card-carddefaultbadge"
              noMargin
              className="card-carddefaultbadge"
            >
              {renderLabel(billingLabels.lbl_billing_default_card, 'lbl_billing_default_card')}
            </Badge>
          ) : (
            ''
          )}
        </BodyCopy>
        {showAddress ? (
          getAddressfromDiffLines(card.addressDetails, dataLocatorPrefix)
        ) : (
          <BodyCopy component="div" fontFamily="secondary" className="card-image-container">
            <CardImage card={card} cardNumber={cardNumber} spc={spc} />
          </BodyCopy>
        )}
        {showAddress && getFormattedAddress(card.addressDetails, dataLocatorPrefix)}
        {showAddress && card.addressDetails.country && (
          <BodyCopy component="p" fontFamily="secondary">
            {card.addressDetails.country}
          </BodyCopy>
        )}
      </BodyCopy>
    )
  );
};

Card.propTypes = {
  card: PropTypes.shape({}),
  className: PropTypes.string,
  dataLocatorPrefix: PropTypes.string,
  fontWeight: PropTypes.string,
  isDefault: PropTypes.bool,
  cardNumber: PropTypes.string,
  showAddress: PropTypes.bool,
  selectedValue: PropTypes.string,
};

Card.defaultProps = {
  isDefault: false,
  cardNumber: '',
  showAddress: false,
  selectedValue: '',
};

export default withStyles(Card, CardStyle);
export { Card as CardVanilla };
